<template>
    <div class="photo-card">
      <div class="image">
        <img class="Photo" :src="Services.imageSrc" alt="Image">
        <div class="text">
          <h2 class="serviceTitle">{{ Services.title }}</h2>
        </div>
      </div>

      </div>
  </template>
  
  <script>
  export default {
    name: 'PhotoCard',
    props: {
    Services: {
            type: Object,
            required: true
    }
    },
  }
  </script>
  
  <style>

.photo-card {
  cursor: pointer; /* Makes the element appear clickable */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for hover effects */
}
  .image {
    height: 25em;
    width: 25em;
    display: flex;
    flex-direction: column;

  }
  .Photo {
    height: 300px;
    width: 400px;
    border-radius: 10px;
    object-fit: cover;
    object-position: center;
  }
  .serviceTitle {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    color: #fff;
    text-shadow: 2px 2px 0px #000000;
    letter-spacing: 2px;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 10px;
    border-radius: 5px;
  }
  </style>